// extracted by mini-css-extract-plugin
module.exports = {"title":"HighlightTitle-module--title--ZiQIg","bg":"HighlightTitle-module--bg--3Oks7","inner":"HighlightTitle-module--inner--3ztQY"};